import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: string;
  dark?: boolean;
};
export function SectionHeading({
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-63" data-mp="3f1vm1h65qdez">
      <h2 className={`font-serif text-3xl font-bold leading-tight sm:text-4xl md:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-64" data-mp="3f3ggz7wdvydd">{title}</h2>
      {subtitle && <p className={`mt-4 text-lg ${dark ? "text-white/75" : "text-muted"}`} data-id="element-65" data-mp="blesdn2p690i">{subtitle}</p>}
    </div>;
}